import { isObjectLike, get } from 'lodash'

type ObjRecordT = string | Record<string, unknown> | any
type CallBackT = (nodeKey: string, value: string) => void

const callForEachNode = (object: ObjRecordT, callack: CallBackT) => {
  Object.keys(object).forEach((nodeKey) => {
    const nodeVal = get(object, nodeKey, '')

    if (isObjectLike(nodeVal)) {
      callForEachNode(nodeVal, callack)
      return
    }

    callack(nodeKey, nodeVal)
  })
}

export default callForEachNode
